import { useContext } from 'react'
import TripsContext from '../contexts/TripsContext'

export const useSearchVehicle = (): any => {
    const { reverseGeocoding, selectedVehicles, markerHashMap, setInfoWindow, setVehiclesSearched, setVehicleActive, vehicles } = useContext(TripsContext)

    const search = (query: string) => {
        selectedVehicles.forEach((ele: any) => {
            const marker = markerHashMap.get(ele.imei)
            marker?.marker.setMap(null);
        })
        selectedVehicles.length = 0;
        
        setInfoWindow(undefined)
        setVehicleActive([])

        if (query === '') {
            setVehiclesSearched(undefined)
        } else {
            const lowerCaseQuery = query.toLowerCase()
            const vehiclesAux = vehicles?.filter(vehicle => {
                const { asset, title, driver, name } = vehicle
                const adressAux = reverseGeocoding[asset?.id]?.address || 'N/A'

                return (
                    title?.toString().toLowerCase().includes(lowerCaseQuery) ||
                    name?.toString().toLowerCase().includes(lowerCaseQuery) ||
                    driver?.toString().toLowerCase().includes(lowerCaseQuery) ||
                    adressAux?.toString().toLowerCase().includes(lowerCaseQuery)
                )
            })

            setVehiclesSearched(vehiclesAux)
        }
    }

    return { search }
}
